export interface ListCheck {
  sessionId: string;
  fromUpdate: number;
}

export function isListCheckSettled(
  check: ListCheck | undefined,
  sessionId: string | undefined,
  dataUpdateCount: number,
  isFetching: boolean,
): boolean {
  return (
    check !== undefined &&
    check.sessionId === sessionId &&
    dataUpdateCount > check.fromUpdate &&
    !isFetching
  );
}
